import React from 'react';

import './NotFound.scss';

function NotFound() {
  return <div>[404] Lo sentimos, la página que visitaste no existe.</div>;
}

export default NotFound;
